import CalendarCancelSolidSVG from "@design-system/ui-icons/vanilla/CalendarCancelSolid"
import { createIcon } from "../createIcon"

export const CalendarCancelSolidIcon = createIcon(CalendarCancelSolidSVG)
